import React, { Fragment, useState, useEffect } from "react";
import { Card, CardBody, Row } from "reactstrap";
import { Image, H6 } from "../../../AbstractElements";
import DriverContent from "./DriverContent";
import AssignBooking from "../AssignBooking";
import { getAvatarText, getUserRole, showAlert } from "../../../Services/Shared.service";
import { getDriverDetails } from "../../../Services/Booking.service";
import LocateDriver from "../LocateDriver";
import NotifyDriver from "../NotifyDriver";
import BlockDriver from "../BlockDriver";
import UnblockConformation from "../UnblockConformation";
import { AirportAgent } from "../../../Data/SideMenu/RouteMapping";
import RetrieveConfirmationModal from "../DriverListing/RetrieveConfirmationModal";
import { getDriverBalance } from "../../../Services/Driver.service";
import { getDriverImage } from "../../../Services/DispatchDashboard.service";
const DriverDetails = ({
  setShowApiLoader,
  driverId,
  globalCityField,
  cityData,
  totalCollectableAmount,
  fetchDriverCollections,
  totalCommissionAmount
}) => {
  const [profileImage, setProfileImage] = useState("");
  const [assignBookingModal, setAssignBookingModal] = useState(false);
  const toggleAssignBookingModal = () =>
    setAssignBookingModal(!assignBookingModal);

  const [locateDriverModal, setLocateDriverModal] = useState(false);
  const toggleLocateDriverModal = () =>
    setLocateDriverModal(!locateDriverModal);

  const [notifyDriverModal, setNotifyDriverModal] = useState(false);
  const toggleNotifyDriverModal = () =>
    setNotifyDriverModal(!notifyDriverModal);

  const [blockDriverModal, setBlockDriverModal] = useState(false);
  const toggleBlockDriverModal = () => setBlockDriverModal(!blockDriverModal);

  const [unblockDriverModal, setUnblockDriverModal] = useState(false);
  const toggleUnBlockDriverModal = () => setUnblockDriverModal(!unblockDriverModal);
  const [retrieveModal, setRetrieveModal] = useState(false);
  const toggleRetrieveModal = () =>
    setRetrieveModal(!retrieveModal);

  const [driverObj, setDriverObj] = useState({});
  const [walletBalance, setWalletBalance] = useState("")
  const userRole = getUserRole()

  useEffect(() => {
    fetchDriverDetails()
  }, []);

  const fetchDriverDetails = () => {
    setShowApiLoader(true);
    getDriverDetails(driverId)
      .then((result) => {
        setShowApiLoader(false);
        if (result.data) {
          setDriverObj(result.data);
          const letter = getAvatarText(result.data?.fullName);
          setProfileImage(letter);
          getDriverImage(driverId)
            .then((imageResult) => {
              if (imageResult.data) {
                setProfileImage(imageResult.data);
              }
            })
            .catch(() => {});
        }
      })
      .catch((err) => {
        setShowApiLoader(false);
        setDriverObj({});
        showAlert("error", err.response?.data?.message ? err.response.data.message : "Something went wrong");
      });
    getDriverBalance(driverId)
      .then((result) => {
        if (result.data) {
          setWalletBalance(result.data.amount)
        }
      })
      .catch((err) => {
        showAlert("error", err.response?.data?.message ? err.response.data.message : "Something went wrong");
      });
  }

  return (
    <Fragment>
      <Card className="driver-details">
        <CardBody>
          <Row className="driver-info">
            {/* <Image
              attrImage={{
                className: "rounded-circle driver-image-alignment",
                alt: "",
                src: `${require("../../../assets/images/booking/customer.png")}`,
              }}
            /> */}
            {profileImage && (profileImage.startsWith("http://") || profileImage.startsWith("https://")) ? (
              <img
                className="rounded-circle img-200 driver-image-alignment"
                style={{ objectFit: "cover" }}
                src={profileImage}
                alt={driverObj.fullName}
              />
            ) : (
              <div className="img-200 h-100 rounded-circle profile-image-box driver-image-alignment">
                <div className="profile-image">{profileImage}</div>
              </div>
            )}

            {driverObj.isDeleted ? <div className="driver-options">
              <button
                className="btn"
                onClick={() => toggleRetrieveModal()}
              >
                <i className="fa fa-mail-forward"></i>Retrieve
              </button>
            </div> : <div className="driver-options">
              {userRole.some((element) => element != AirportAgent) ? <button
                className="btn"
                onClick={() => toggleAssignBookingModal()}
                disabled={driverObj.isAvailable ? false : true}
              >
                <i className="fa fa-user-plus"></i>Assign

              </button> : null}
              <button className="btn" onClick={() => toggleLocateDriverModal()}>
                <i className="fa fa-map-marker"></i>
                Locate
              </button>
              <button className="btn" onClick={() => toggleNotifyDriverModal()}>
                <i className="fa fa-bell"></i>
                Notify
              </button>
              {userRole.some((element) => element != AirportAgent) ? <button className="btn" onClick={() => {
                if (driverObj?.isAvailable) {
                  toggleBlockDriverModal()
                } else {
                  toggleUnBlockDriverModal()
                }
              }}>
                <i className="fa fa-ban"></i>
                {driverObj?.isAvailable ? "Block" : "Unblock"}
              </button> : null}
            </div>}
            <div className="driver-content">
              <DriverContent driverObj={driverObj} walletBalance={walletBalance} totalCollectableAmount={totalCollectableAmount} fetchDriverCollections={fetchDriverCollections} totalCommissionAmount={totalCommissionAmount}/>
            </div>
          </Row>
        </CardBody>
      </Card>
      <AssignBooking
        LargeModaltoggle={toggleAssignBookingModal}
        title={"Assign Booking"}
        Large={assignBookingModal}
        setShowApiLoader={setShowApiLoader}
        assignBookingDriverObj={driverObj}
        globalCityField={globalCityField}
      />
      <LocateDriver
        LargeModaltoggle={toggleLocateDriverModal}
        title={"Locate Driver"}
        Large={locateDriverModal}
        setShowApiLoader={setShowApiLoader}
        cityData={cityData}
        driverObj={driverObj}
      />
      <NotifyDriver
        LargeModaltoggle={toggleNotifyDriverModal}
        title={"Push Notification"}
        Large={notifyDriverModal}
        setShowApiLoader={setShowApiLoader}
        driverObj={driverObj}
      />

      <BlockDriver
        LargeModaltoggle={toggleBlockDriverModal}
        title={"Block Driver"}
        Large={blockDriverModal}
        setShowApiLoader={setShowApiLoader}
        driverObj={driverObj}
        fetchDriverData={fetchDriverDetails}
      />
      <UnblockConformation
        LargeModaltoggle={toggleUnBlockDriverModal}
        title={"Unblock Driver"}
        Large={unblockDriverModal}
        setShowApiLoader={setShowApiLoader}
        driverObj={driverObj}
        fetchDriverData={fetchDriverDetails}
      />
      <RetrieveConfirmationModal
        Large={retrieveModal}
        title={"Retrieve Driver"}
        LargeModaltoggle={toggleRetrieveModal}
        fetchData={fetchDriverDetails}
        driverObj={driverObj}
      />
    </Fragment>
  );
};

export default DriverDetails;
